var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"v-widget",class:{
    'v-widget--active': _vm.active,
  },style:({
    '--widget-color': _vm.widgetColor,
  })},[_c('v-card-header',{staticClass:"text-white",style:({
      '--widget-color': _vm.widgetColor,
    })},[_vm._t("header")],2),_vm._v(" "),_c('v-card-content',[(_vm.loading)?_c('div',{staticClass:"v-widget__loading-overlay"},[_c('default-preloader')],1):_vm._e(),_vm._v(" "),_vm._t("content")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }